import { ATTACHMENT_BOUNDARY_PATH_PREFIX } from "../../common/constants";

export const CLIENT_DOCUMENT_SIGN_PREFIX = "/client-doc-signatures";

export const CLIENT_DOCUMENT_SIGN_PATHS = {
  confirm: { to: `${CLIENT_DOCUMENT_SIGN_PREFIX}/confirm` },
  originalFile: { to: `${ATTACHMENT_BOUNDARY_PATH_PREFIX}/clients/:id1/doc-signatures/:id2/original-file` },
  signedFile: { to: `${ATTACHMENT_BOUNDARY_PATH_PREFIX}/clients/:id1/doc-signatures/:id2/signed-file` },
};
